<template>
  
    <v-navigation-drawer v-model="menuLateralShow" fixed temporary stateless>
      <v-list class="pa-1">
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>Menu</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
              <v-btn icon @click.stop="$emit('fecha-menu-lateral')">
                  <v-icon>close</v-icon>
              </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <v-list class="pt-0" dense>
        <v-divider></v-divider>

        <v-list-tile v-for="item in menulateral" :key="item.title">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content v-if="item.href">
            <v-list-tile-title><a :href="item.href" target="_blank">{{ item.title }}</a></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
 
</template>
<script>
export default {
  props: ["menuLateralShow","menulateral"],
  data() {
    return {
      items: [
        { title: "Home", icon: "dashboard", content: "" },
        { title: "About", icon: "question_answer", content:"" },
        { title: "Instagram", icon: "", href: "" },
        { title: "Facebook", icon: "", href: "" },
        { title: "You Tube", icon: "", href: "" },
        { title: "Linkedin", icon: "", href: "" },
        { title: "Twitter", icon: "", href: "" },
      ],
      right: null
    };
  }
};
</script>